import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
            为你精心挑选的专题内容，发现更多精彩
          </p>
          <div className="flex flex-col gap-6 md:gap-8">
            {carouselData.map((item, idx) => (
              <div
                key={idx}
                className={`flex flex-col ${idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-6 md:gap-8 rounded-2xl bg-background-50 border border-background-200 overflow-hidden hover:shadow-sm transition-all duration-200 cursor-pointer group`}
              >
                <div className="lg:w-[45%] aspect-[16/10] lg:aspect-auto overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 flex flex-col justify-center p-6 md:p-8">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                    <span className="text-xs text-foreground-400 font-medium">专题 {idx + 1}</span>
                  </div>
                  <h3 className="font-heading text-xl md:text-2xl text-foreground-950 mb-3 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                  <div className="mt-5">
                    <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:gap-2.5 transition-all">
                      探索更多
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}